import { CartographyResource } from './cartography-resource';
import { CartographyResourceInfosPositionMat } from '../cartography-resource-infos/cartography-resource-infos-position/cartography-resource-infos-position-mat';
import { UserSettings } from '../../engine/user-settings';
import { signal, WritableSignal } from '@angular/core';
import { MarkerContentGenerator } from '../../engine/marker-content-generator';

export class CartographyResourceMat extends CartographyResource {
  public color: string;

  public override options: google.maps.MarkerOptions = {
    zIndex: 100,
  };

  public content: WritableSignal<HTMLDivElement> = signal(null);

  public override updatePosition(
    position: CartographyResourceInfosPositionMat,
  ) {
    super.updatePosition(position);
    if (!this.checkPosition(position)) {
      return;
    }
    this.updateContent();
  }

  public getIconMarker(): string {
    const icon = this.icon ? this.icon : 'toolbox';
    const size = UserSettings.markerSize;
    return `assets/img/google-map/markers/mat/${icon}-size${size}.svg`;
  }

  public refreshOptions(): void {
    this.options = {
      ...this.options,
      ...{ icon: this.getIconMarker() },
    };
  }

  public updateContent(): void {
    this.content.set(
      MarkerContentGenerator.generateMarkerContent({
        resource: this,
        label: [this.label],
        icon: this.icon,
        color: this.iconColor,
      }),
    );
  }
}
